import type { NearbySpotData } from "./api-types";
import type { NearbySuggestion } from "./types";

const MIN_SCORE = 5.0; // a nearby spot must be at least "good"
const MIN_DELTA = 1.5; // and clearly better than the current spot

/**
 * Choose a nearby spot to suggest when the current spot is poor for the active
 * sport. Returns null unless a nearby spot is materially better, so we never
 * push people elsewhere on a marginal call.
 */
export function pickNearbySuggestion(
  nearby: NearbySpotData[],
  scoringKey: string,
  currentBest: number,
  sportLabel: string
): NearbySuggestion | null {
  let best: { spot: NearbySpotData; score: number } | null = null;
  for (const spot of nearby) {
    const score = spot.bestScoreBySport[scoringKey];
    if (score == null) continue;
    if (score < MIN_SCORE) continue;
    if (score < currentBest + MIN_DELTA) continue;
    if (!best || score > best.score) best = { spot, score };
  }
  if (!best) return null;
  return {
    slug: best.spot.slug,
    name: best.spot.name,
    distanceKm: best.spot.distanceKm,
    score: best.score,
    note: `${best.spot.name} (${Math.round(best.spot.distanceKm)} km away) is scoring better for ${sportLabel} right now. Worth the trip if you can make it.`,
  };
}
